import {emptyObject} from '../../../../../../utils/empty'
import type {RuleCommon, RuleParameters} from '../Rules.types'

import type {CleanupFormState} from './CleanupForm.types'
import {branchesActivityConverter, branchPatternConverter} from './Sections/BranchesSection'
import {buildStatusConverter} from './Sections/BuildStatusSection'
import {personalConverter} from './Sections/PersonalSection'
import {preserveConverter} from './Sections/PreserveSection'
import {tagsConverter} from './Sections/TagsSection'
import {willApplyConverter} from './Sections/WillApplySection'

export const adaptRuleUiToApi = (
  state: CleanupFormState,
  disabled: boolean | null | undefined,
): RuleCommon & RuleParameters => ({
  ruleDisabled: disabled ?? false,
  keepBuildParts: preserveConverter.toRule(state.preserve),
  limit: state.limit,
  filters: {
    tags: state.tags.length
      ? {
          tagsList: tagsConverter.toRule(state.tags),
        }
      : null,
    buildStatus: buildStatusConverter.toRule(state.status) || null,
    activeBranch: branchesActivityConverter.toRule(state.activeBranch),
    branchPattern: branchPatternConverter.toRule(state.branchPattern),
    personalBuild: personalConverter.toRule(state.personal),
  },
  partitions: willApplyConverter.toRule(state.willApply),
  params: emptyObject,
  preserveArtifacts: state.preserveArtifacts,
})
